<template>
    <Head :title="translate('check.teaser:headlines').join(' ')" />

    <div class="mx-auto max-w-3xl pb-8" style="min-height: 50vh">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left">
            <div>
                <Teaser :headlines="translate('check.teaser:headlines')"></Teaser>
            </div>
        </div>
        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-3xl sm:mx-auto sm:overflow-hidden">
                <CheckUploadBox :nft="nft"></CheckUploadBox>
            </div>
        </div>
        <Steps :step="1"></Steps>

    </div>
</template>

<script>
import FAQ from './../../Components/FAQ';
import CheckUploadBox from './../../Components/CheckUploadBox';
import Steps from "../../Components/Steps";
import {Head, usePage} from '@inertiajs/inertia-vue3'
import translate from "../../../lang";
import Teaser from "../../Components/Common/Teaser";


export default {
    components: {
        Teaser,
        Steps,
        FAQ,
        CheckUploadBox,
        Head
    },
    props: {
        nft: Object,
        redirectUrl: {
            type: String,
            required: true
        }
    },
    setup() {
        return {translate: translate('upload-' + usePage().props.value.metaDataType.type)}
    },
    created() {
        setTimeout(() => {
            this.$inertia.visit(this.redirectUrl);
        }, 5000)
    }
}
</script>
